import {Component, Input, OnInit} from "@angular/core";
import {IAnswer, IFormField} from "../form-field-wrapper/form-field-wrapper.component";
import {UntypedFormControl, Validators} from "@angular/forms";

@Component({
    selector: "app-radio-field",
    templateUrl: "./radio-field.component.html",
    styleUrls: ["./radio-field.component.scss"],
    standalone: false
})
export class RadioFieldComponent implements OnInit {
  @Input() question: IFormField;
  @Input() myFormControl: UntypedFormControl;
  @Input() radioName?: string;
  @Input() disabled?: boolean;
  @Input() tabIndex?: number = 0;

  constructor() {
  }

  ngOnInit() {
  }

}

const radioFieldValidators = (question: IFormField) => {
  const validators = [];
  if (question.mandatory) validators.push(Validators.required);
  return validators;
};

export const makeRadioFieldFormControl = (q: IFormField, answer?: IAnswer) => {
  const formControlValue = answer ? answer.answer : (q.default != null ? String(q.default) : "");
  q.validators = radioFieldValidators(q);
  const formControl = new UntypedFormControl(formControlValue, {validators: Validators.compose(q.validators)});
  if (!answer && formControlValue) {
    formControl.markAsDirty();
  }
  return formControl;
};
